<template>
<div v-if="devolucion_items">
    <Box  @close="close(false)">
        <template #top>Devolución N° {{ dei_id }}</template>
        <template #center>
            <div class="nj-panel">
                <div class="nj-panel-content">
                    <div class="nj-subtitle-1">Datos</div>
                    <div class="nj-grid">
                        <LabelGroup label="Solicitante" :value="devolucion_items.emp_solicitante_nombre"></LabelGroup>
                        <LabelGroup label="Autorizador" :value="devolucion_items.emp_autorizador_nombre"></LabelGroup>
                        <LabelGroup label="Fecha de asignación" :value="devolucion_items.ait_fecha_registro"></LabelGroup>
                    </div>
                    <br>
                    <div class="nj-subtitle-1">Items</div>
                    <b-table :data="devolucion_items.lista_devolucion_items_detalle">
                        <template slot-scope="props">
                            <b-table-column label="ID (prod-almacen)" header-class="is-info">{{ props.row.pal_id }}</b-table-column>
                            <b-table-column label="Producto" header-class="is-info">{{ props.row.prv_nombre }}</b-table-column>
                            <b-table-column label="Cantidad asignada" header-class="is-info">{{ props.row.aid_cantidad }}</b-table-column>
                            <b-table-column label="Cantidad devuleta" header-class="is-info">{{ props.row.did_cantidad }}</b-table-column>
                            <b-table-column label="Observaciones" header-class="is-info">{{ props.row.did_notas }}</b-table-column>
                        </template>
                    </b-table>
                </div>
            </div>
        </template>
    </Box>
</div>
</template>

<script>
import { LabelGroup, Box } from "../components"

import Toast from "../../util/toast"
import { DevolucionItemsService } from "../../rest"

export default {
    name: "VerDevolucionItems",
    props: {
        dei_id: {
            type: Number
        }
    },
    components: {
        LabelGroup,
        Box,
    },
    data() {
        return {
            devolucion_items: null
        }
    },
    methods: {
        obtener() {
            DevolucionItemsService.obtener({
                dei_id: this.dei_id
            }).then(
                response => {
                    this.devolucion_items = response.data
                },
                error => {
                    Toast.error(error)
                    console.error(`error: `, error)
                }
            )
        },
        close() {
            this.$emit("close", false)
        },
    },
    mounted() {
        this.obtener()
    }
}
</script>

<style scoped></style>